import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './MirrorJoin.module.scss';

function ConnectInfoModal({ show, onHide, ctaText = "Got it!" }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            dialogClassName="connectInfoModal"
        >
            <Modal.Body className={styles.modalBody}>
                <svg className={styles.modalHeroIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                    <line x1="8" y1="21" x2="16" y2="21" />
                    <line x1="12" y1="17" x2="12" y2="21" />
                </svg>
                <h3 className={styles.modalTitle}>What is Connect?</h3>

                <div className={styles.modalProse}>
                    <p>Game.City Connect lets up to 8 households join your game from anywhere.</p>
                    <p>Share your room code with whoever you want playing - they head to <strong>game.city/connect</strong>, enter the code, and your game appears on their screen too. They join as players from their phones, just like the people in your room.</p>
                    <p>Your TV stays the host - that's the screen everyone sees the action on. Their screens become their connection point.</p>
                    <p><em>Family game night, long-distance edition. Sorted.</em></p>
                    <p className={styles.modalProseFinal}>Up to 8 remote screens. Same room or different houses - it all works.</p>
                </div>

                <button className={styles.modalCta} onClick={onHide}>
                    {ctaText}
                </button>
            </Modal.Body>
        </Modal>
    );
}

export default ConnectInfoModal;
